import type { RouteRecordRaw } from 'vue-router'

export const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'home',
    component: () => import('@/views/Home.vue')
  },
  {
    // 兼容旧路径：原生产站点 /yfb 隐分宝入口已迁移到 /。
    // 历史外链（书签、应用商店介绍页、搜索引擎老结果）命中此路径时直接重定向到首页。
    // 见 docs/mainadr/0006-client-sunset-route.md。
    path: '/yfb',
    redirect: '/'
  },
  {
    // APP 下架过渡公告页（仅 zh-CN，隐藏入口，noindex follow）。
    // 见 docs/mainadr/0006-client-sunset-route.md。
    path: '/client',
    name: 'client',
    component: () => import('@/views/Client.vue')
  },
  {
    path: '/install',
    name: 'install',
    component: () => import('@/views/Install.vue')
  },
  {
    // 旧入口（Q1 改造前）：/install/store（UA 检测 + 浏览器选择）
    // 已被新单页表格 /install 取代。历史外链（书签、商店介绍页）命中此路径时跳到新表格。
    // 见 docs/mainpages/install.md。
    path: '/install/store',
    redirect: '/install'
  },
  {
    // 旧中间层（Q1 改造前）：/install/store/:browser（平台选择）
    // 已被新单页表格取代，跳到 /install。
    path: '/install/store/:browser',
    redirect: '/install'
  },
  {
    // 详情页（被新表格「教程」按钮引用）：保留
    path: '/install/store/:browser/:platform',
    component: () => import('@/views/install/InstallDetail.vue')
  },
  {
    // 手动安装页（被新表格 Chrome-desktop-manual / Chromium-desktop-manual 行的「教程」按钮引用）：保留
    path: '/install/manual',
    component: () => import('@/views/install/ManualInstall.vue')
  },
  {
    // 使用指南（how-to 操作手册，与法律 /terms#specific-features「使用说明/声明」区分）。
    // 见 CONTEXT.md「使用指南 vs 使用说明」术语区分。
    path: '/guide',
    name: 'guide',
    component: () => import('@/views/Guide.vue')
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('@/views/About.vue')
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: () => import('@/views/Privacy.vue')
  },
  {
    path: '/terms',
    name: 'terms',
    component: () => import('@/views/Terms.vue')
  },
  {
    path: '/refund',
    name: 'refund',
    component: () => import('@/views/Refund.vue')
  },
  {
    // 邀请规则（公开页：邀请链接会被分享到站外，被邀请人打开时可能未注册，故无需登录）
    path: '/invite-rules',
    name: 'inviteRules',
    component: () => import('@/views/InviteRules.vue')
  },
  {
    // 历史路径 /usage 已合并到 /terms 的"特定功能使用声明"章节。
    // 旧外链（书签、商店介绍页、SEO 收录）命中此路径时跳转到 Terms 页对应锚点。
    // 见 docs/mainadr/0007-legal-pages-restructure.md。
    path: '/usage',
    redirect: '/terms#specific-features'
  },
  {
    // 登录 / 注册 / 忘记密码（运行时页面：表单 + API）
    path: '/login',
    name: 'login',
    component: () => import('@/views/Login.vue')
  },
  {
    // 扩展登录完成中转页（运行时页面）：官网登录成功后跳此页，token 带在 URL 中，
    // 由浏览器扩展的 background SW 读取并写入 chrome.storage（无需 web→extension 导航）。
    // 页面自身只展示提示、不清 URL，避免 SW 读取 tab.url 时拿不到 token。
    path: '/login/callback',
    name: 'login-callback',
    component: () => import('@/views/LoginCallback.vue')
  },
  {
    // 个人中心（需登录；未登录跳 /login?redirect=/account）
    path: '/account',
    name: 'account',
    component: () => import('@/views/Account.vue')
  },
  {
    // 订阅页（套餐 + 折扣 + 邀请 + 兑换码）
    path: '/subscribe',
    name: 'subscribe',
    component: () => import('@/views/Subscribe.vue')
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'notFound',
    component: () => import('@/views/NotFound.vue')
  }
]